export default [
  {
    id: 'tiktok-product',
    name: 'Tiktok x100',
    plan: 'tiktok',
    title: 'Tiktok x100',
    subTitle: '',
    price: 100000,
    beforePrice: 0,
    totalMonths: 0,
    description: ['Sao chép 100 sản phẩm từ Shopee sang Tiktok'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/tiktok.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'tiktok-product-300',
    name: 'Tiktok x300',
    plan: 'tiktok',
    title: 'Tiktok x300',
    subTitle: '',
    price: 200000,
    beforePrice: 300000,
    totalMonths: 0,
    description: ['Sao chép 300 sản phẩm từ Shopee sang Tiktok'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/tiktok.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'tiktok-product-1000',
    name: 'Tiktok x1000',
    plan: 'tiktok',
    title: 'Tiktok x1000',
    subTitle: '',
    price: 500000,
    beforePrice: 1000000,
    totalMonths: 0,
    description: ['Sao chép 1000 sản phẩm từ Shopee sang Tiktok'],
    promotion: [],
    hotPrice: '',
    bestChoice: false,
    logo: '/img/tiktok.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
  {
    id: 'tiktok-product-3000',
    name: 'Tiktok x3000',
    plan: 'tiktok',
    title: 'Tiktok x3000',
    subTitle: '',
    price: 1000000,
    beforePrice: 3000000,
    totalMonths: 0,
    description: ['Sao chép 3000 sản phẩm từ Shopee sang Tiktok'],
    promotion: [],
    hotPrice: '',
    bestChoice: true,
    logo: '/img/tiktok.png',
    badge: null,
    disabled: false,
    promotionStartDate: '',
    promotionEndDate: '',
  },
];
